import { Component } from 'react';

/**
 * Iter 88 — ErrorBoundary racine.
 *
 * Catch toute exception levée pendant le rendu React des descendants et
 * affiche un fallback UI au lieu de la page blanche silencieuse.
 *
 * Log obligatoire en console pour debug (le développeur retrouve l'erreur
 * dans la console navigateur). Pas de notification externe (Sentry/Brevo) en V1
 * — à ajouter dans une P2 séparée si besoin.
 *
 * Cf. /tmp/VERDICT-TERRAIN-13mai.md P0.2, incident SelectItem 12 mai 2026.
 */
export default class ErrorBoundary extends Component {
  state = { hasError: false, error: null, info: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error);
    console.error('[ErrorBoundary] componentStack:', info?.componentStack);
    this.setState({ info });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = '/dashboard';
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const message = this.state.error?.message || 'Erreur inconnue';

    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 24,
          background: '#FAFAF8',
        }}
      >
        <div
          style={{
            maxWidth: 520,
            background: 'white',
            border: '1px solid #E0E0DB',
            padding: 32,
            boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
          }}
        >
          <div
            style={{
              fontSize: 14,
              color: '#C75B39',
              fontWeight: 600,
              marginBottom: 8,
              letterSpacing: 1,
              textTransform: 'uppercase',
            }}
          >
            Une erreur est survenue
          </div>
          <h1
            style={{
              fontFamily: 'DM Serif Display, serif',
              fontSize: 22,
              color: '#2C2C2C',
              margin: '0 0 16px 0',
            }}
          >
            L'application a rencontré un problème
          </h1>
          <p style={{ color: '#6B6B6B', fontSize: 14, lineHeight: 1.5, marginBottom: 16 }}>
            Vos données enregistrées avant cette erreur sont sauvegardées. Vous pouvez :
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
            <button
              onClick={this.handleReload}
              style={{
                background: '#2C2C2C',
                color: 'white',
                border: 'none',
                padding: '12px 16px',
                fontSize: 14,
                fontWeight: 500,
                cursor: 'pointer',
              }}
            >
              Recharger l'application
            </button>
            <button
              onClick={this.handleHome}
              style={{
                background: 'white',
                color: '#2C2C2C',
                border: '1px solid #E0E0DB',
                padding: '12px 16px',
                fontSize: 14,
                cursor: 'pointer',
              }}
            >
              Retour au tableau de bord
            </button>
          </div>
          <details style={{ fontSize: 12, color: '#9A9A9A', marginTop: 8 }}>
            <summary style={{ cursor: 'pointer' }}>Détails techniques (à transmettre au support)</summary>
            <pre
              style={{
                background: '#F5F5F3',
                padding: 12,
                marginTop: 8,
                fontSize: 11,
                overflow: 'auto',
                maxHeight: 200,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
              }}
            >
              {message}
              {this.state.info?.componentStack ? '\n\n' + this.state.info.componentStack : ''}
            </pre>
          </details>
        </div>
      </div>
    );
  }
}
